import { render, staticRenderFns } from "./MainBookCompPrintPS.vue?vue&type=template&id=1415e5e4&scoped=true"
import script from "./MainBookCompPrintPS.vue?vue&type=script&lang=js"
export * from "./MainBookCompPrintPS.vue?vue&type=script&lang=js"
import style0 from "./MainBookCompPrintPS.vue?vue&type=style&index=0&id=1415e5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415e5e4",
  null
  
)

export default component.exports